<template>
  <div>
    <v-container>
      <v-row>
        <v-col :cols="12">
          <v-text-field
            :label="'Service Name'"
            v-model="service.name"
          ></v-text-field>
        </v-col>

        <v-col :cols="12"
          ><v-text-field
            :label="'Service Fee'"
            type="number"
            v-model="service.price"
          ></v-text-field
        ></v-col>

        <v-col :cols="12">
          <v-text-field
            :label="'Quantity'"
            v-model="service.quantity"
          ></v-text-field>
        </v-col>

        <v-col :cols="6"
          ><v-btn @click="regeneratePDF()" color="teal" dark
            ><v-icon>mdi-check</v-icon>Add Service</v-btn
          ></v-col
        >
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
export default {
  data: () => ({
    service: {
      name: null,
      cost: 0,
      price: 0,
      code: "SX-192-01",
      category_id: 0,
      serviceCategory: "General Service",
      list_on_store: "No",
      item_type: "service",
      quantity: 1,
      category: {
        id: 0,
        name: "General Service",
      },
      inventory: {
        amount_in_stock: "0",
        amount_received: "0",
        amount_sold: "0",
        id: 1,
        product_id: "0",
        quantity_in_stock: "9999999999999999",
        quantity_received: "9999999999999999",
        quantity_sold: "0",
      },
      imagePath: "/images/products/no-photo.jpg",
      link: "12121111211",
    },
  }),

  methods: {
    regeneratePDF() {
      if (!this.service.name) {
        alert("Service Name is Required!");
        return false;
      }
      this.service.price = this.stripNonDigitsAndCommasFromMoney(
        this.service.price
      );
      this.$emit("service-updated", this.service);
    },
    stripNonDigitsAndCommasFromMoney(amount) {
      return helpersJs.stripNonDigitsAndCommasFromMoney(amount);
    },
  },
};
</script>

<style></style>
